angular.module('SpidApp')

.controller('InventoryController', 
		['$scope', 'InventoryService', 'Inventory', '_', '$stateParams', 'StockService', 'StockManager', 'ProductService', 'OperationalProductService', 'Toaster', '$timeout',    
function ($scope,   InventoryService,   Inventory,   _,   $stateParams,   StockService,   StockManager,   ProductService,   OperationalProductService,   Toaster,   $timeout) {
    
	if (!$stateParams.agencyId) {
        throw 'InventoryController() - You should provide an agency id'
    }
	if (!$stateParams.userId) {
        throw 'InventoryController() - You should provide an user id'
    }
    
    var agencyId = $stateParams.agencyId
    var userId 	 = $stateParams.userId
    
    $scope.lastInventoryDiffStock = 0;
    
    var getAllInventories = function() {
    	return InventoryService.findByAgencyId(agencyId).then(function(inventories) {
	    	var inventoryPro = _.chain(inventories).filter(function(inventory) {
	    		return inventory.type === 'PRO';
	    	}).last().value();
	    	
    		if (inventoryPro) {
	    		$scope.lastInventoryProDate  	= inventoryPro.updated_at;
		    	$scope.lastInventoryDiffStock	= inventoryPro.diffStock;
	    	}
	    	
	    	var inventoryOpe = _.chain(inventories).filter(function(inventory) {
	    		return inventory.type === 'OPE';
	    	}).last().value();
	    	
	    	
	    	if (inventoryOpe) {
	    		$scope.lastInventoryOpeDate = inventoryOpe.updated_at;
	    	}
	    });
    }
    
    var fetchStocks = function () {
		return StockService.findByAgencyId(agencyId).then(function (stocks) {
	        $scope.stocks = stocks;
		});
	}
    
    var fetchInventoryProducts = function() {
		console.log($scope);
    	return ProductService.all().then(function (products) {
	    	var stockProducts = _.chain(StockManager.agregateProductAndStock(products, $scope.stocks)).sortBy(function (stockProduct) {
	            return stockProduct.product.category;
	        }).value();
	    	
	    	$scope.inventoryProducts = _.map(stockProducts, function(stockProduct){
	        	return {
	        		product		: stockProduct.product,
	        		qtyOrigine	: stockProduct.quantity,
					commentaire : $scope.commentaire,
	        		quantity 	: 0
	        	}
	        });
	    })
    }
    
    var fetchInventoryProductsOp = function() {
    	return OperationalProductService.all().then(function (operationalProducts) {
        	var stockProducts = _.chain(StockManager.agregateProductAndStock(operationalProducts, $scope.stocks)).sortBy(function (stockProduct) {
                return stockProduct.product.category;
            }).value();
        	
        	$scope.inventoryProductsOp = _.map(stockProducts, function(stockProduct){
	        	return {
	        		product		: stockProduct.product,
	        		qtyOrigine	: stockProduct.quantity,
	        		quantity 	: 0
	        	}
	        });
    	})
    }
    
    var fetchInventory = function() {
    	fetchStocks().then(function(){
    		fetchInventoryProducts();
    	}).then(function () {
	        fetchInventoryProductsOp();
	    }).then(function() {
	    	getAllInventories();
	    });
    }
    fetchInventory();
    
    
    $scope.saveInventoryProduct = function() {
        var inventoryProducts = createInventory($scope.inventoryProducts, 'PRO');
    	
    	InventoryService.save(inventoryProducts, agencyId, userId).then(function() {
            $scope.printProduct();
			return fetchInventoryProducts();
		}).then(function() {
			getAllInventories();
		}).then(function() {
			Toaster.show("L'inventaire des produits à la vente a été sauvegardé")
		});
    }
    
    $scope.saveInventoryProductOp = function() {
    	var inventoryProductsOp = createInventory($scope.inventoryProductsOp, 'OPE');
    	
    	InventoryService.save(inventoryProductsOp, agencyId, userId).then(function() {
            $scope.printProductOp();
			return fetchInventoryProductsOp();
		}).then(function() {
			getAllInventories();
		}).then(function() {
			Toaster.show("L'inventaire des produits de fonctionnement a été sauvegardé")
		});
    }
    
    var createInventory = function(productsArray, type) {
    	var diffStock = _.reduce(productsArray, function(memo, product) {
			return memo + (product.quantity - (product.qtyOrigine || 0)) * (product.product.price || 0);
		}, 0);
    	
    	var diffInventory = 0;
    	if (type === 'PRO') {
    		diffInventory = diffStock - $scope.lastInventoryDiffStock	
    	}
    	
    	return {
    			user_id			: userId
    			, agency_id 	: agencyId
    			, type 			: type
    			, products		: JSON.stringify(productsArray)
    			, diffStock 	: diffStock
    			, diffInventory : diffInventory
    	}
    }
    
    $scope.resetQuantity = function(item) {
    	if (item.quantity) {
    		item.quantity = 0;
    		Toaster.show('La valeur d\'inventaire pour <b>' + item.product.label + '</b> a été réinitialisé')
    	}
    }
    
    $scope.resetInventoryProduct = function() {
		fetchInventoryProducts().then(function() {
			Toaster.show('Les valeurs d\'inventaire pour les produits de vente ont été réinitialisés')
		})
    }
    
    $scope.resetInventoryProductOp = function() {
		fetchInventoryProductsOp().then(function() {
			Toaster.show('Les valeurs d\'inventaire pour les produits de focntionnement ont été réinitialisés')
		})
    }
    
    $scope.printProduct = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
    	$timeout(function() {
    		window.print();
    	}, 50);
	}
    
    $scope.printProductOp = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
    	$timeout(function() {
    		window.print();
    	}, 50);
    }
    
}])
